import React, { useContext, useEffect, useState } from 'react';
import { Layout } from 'antd';
import { Navigation, OnlineUsers, Search, UserMenu } from '.';
import { NavLink } from 'react-router-dom';
import { SizeMe } from 'react-sizeme';
import { UserContext } from '../contexts';
import { isSuperadmin } from '../../utils';

export function Header() {
  const { Header } = Layout;
  const { user } = useContext(UserContext);

  const [isTestEnv, setIsTestEnv] = useState(false);
  const [canSeeSearchPanel, setCanSeeSearchPanel] = useState(false);

  useEffect(() => {
    setIsTestEnv(window.location.hostname.includes('mdmtest.') || window.location.hostname.includes('mdm.setwiser.com'));
  }, []);

  useEffect(() => {
    if (user) {
      const hasSearchPanelPermission = isSuperadmin(user);
      setCanSeeSearchPanel(hasSearchPanelPermission);
    }
  }, [user]);

  const maskCustomerName =
    (process.env.REACT_APP_MDM_ENV !== 'test' || window.location.hostname.includes('mdm.setwiser.com')) &&
    process.env.REACT_APP_MDM_ENV !== 'prod';

  return (
    <SizeMe>
      {({ size }) => (
        <Header style={{ display: 'flex', justifyContent: 'space-between', zIndex: 10, backgroundColor: '#294D78' }}>
          <div>
            <NavLink to="/">
              <h1 style={{ display: 'flex', alignItems: 'center', color: '#fff' }}>
                {!maskCustomerName && <img src="/rs_logo.png" alt="Roketsan" width={30} height={30} style={{ marginRight: '1rem' }} />}
                <span>{!size?.width || size?.width >= 1250 ? 'Ana Veri Yönetimi' : 'AVY'}</span>
                {isTestEnv && (
                  <span style={{ marginLeft: '1rem', color: '#ff0000' }}>{!size?.width || size?.width >= 1250 ? 'TEST' : 'T'}</span>
                )}
              </h1>
            </NavLink>
          </div>
          {canSeeSearchPanel && (
            <div style={{ display: 'flex', alignItems: 'center', flexGrow: 1, maxWidth: '23rem', margin: '0 4rem' }}>
              <Search />
            </div>
          )}
          <div style={{ flexGrow: 1 }}>
            <Navigation />
          </div>
          <div style={{ marginLeft: '2rem' }}>
            <OnlineUsers />
          </div>
          <div style={{ marginLeft: '2rem' }}>
            <UserMenu headerSize={size} />
          </div>
        </Header>
      )}
    </SizeMe>
  );
}
